import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    encryption: false // 是否加密
}

export const EncryptionSlice = createSlice({
    name: 'EncryptionSlice',
    initialState,
    reducers: {
        updateFlagEncryption: (state, action) => {
            state.encryption = action.payload
        }
    },
    extraReducers: {},
})
